class GirotondoConfigurator extends HTMLElement {
  constructor() {
    super();
    this.productRoot = this.closest('.product') || document;

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, this.addOptionHints.bind(this));
    }

    this.addOptionHints();
  }

  addOptionHints() {
    const hints = {
      Cornice: '(legno +5€)',
    };
    Object.entries(hints).forEach(([optionName, hintText]) => {
      const input = this.productRoot.querySelector(`input[data-option-name="${optionName}"]`);
      const fieldset = input ? input.closest('fieldset') : null;
      const legend = fieldset ? fieldset.querySelector('legend') : null;
      if (!legend || legend.querySelector('.girotondo-configurator__hint')) return;
      const span = document.createElement('span');
      span.className = 'girotondo-configurator__hint';
      span.textContent = ' ' + hintText;
      legend.appendChild(span);
    });
  }
}

customElements.define('girotondo-configurator', GirotondoConfigurator);
